import { gql } from '@apollo/client';

const UPDATE_DUE_DATE = gql`
  mutation UpdateDueDate($accountId: String!, $newDueDateDay: Int!) {
    updateDueDate(accountId: $accountId, newDueDateDay: $newDueDateDay) {
      success
      errors
    }
  }
`;

export { UPDATE_DUE_DATE };
